module.exports = __webpack_public_path__ + "img/pix.53272623.svg";